import React from 'react'
import { FiArrowRightCircle, FiBox } from "react-icons/fi";
import { Link } from 'react-router-dom';

export const Hero = () => {
    return (
        <section className="hero-section-two bgs-cover rel z-2 pt-205 pb-250 rpt-150 rpb-50" style={{backgroundImage: 'url(/img/hero-bg.png)'}}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-9">
                        <div className="hero-content-two text-center text-white rpt-20">
                            <span className="sub-title wow fadeInUp delay-0-2s" style={{visibility: 'visible', animationName: 'fadeInUp'}}>Melayani Sepenuh Hati</span>
                            <h1 className="mb-15 wow fadeInUp delay-0-4s" style={{visibility: 'visible', animationName: 'fadeInUp'}}>Dinas Pendidikan dan Kebudayaan</h1>
                            <p className="wow fadeInUp delay-0-5s" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
                                Website resmi Dinas Pendidikan Kabupaten Lampung Timur. Semua informasi yang tertera disini adalah informasi yang valid dan pelayanan yang tertera pada website ini tidak dipungut biaya apapun.
                            </p>
                            <div className="hero-btns mt-40 wow fadeInUp delay-0-8s" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
                                <Link to={'/home'} className="theme-btn style-four">Masuk Website <FiArrowRightCircle className='hero-portal-icon' /></Link>
                                <Link to={'/informasi/bank-data'} className="theme-btn style-five">Bank Data <FiBox className='hero-portal-icon' /></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="section-alpha-text mb-250"></div>
            <img className="dots-shape" src="/img/white-dots.png" alt="Shape" />
            <img className="tringle-shape" src="/img/white-tringle.png" alt="Shape" />
            <img className="close-shape" src="/img/white-close.png" alt="Shape" />
            <div className="left-circles"></div>
            <div className="right-circles" ></div>
        </section>
    )
};